import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => (
  <div className="bg-ehh-cream text-ehh-navy">
    {/* Hero Section - Added faith-based statement and lightened overlay */}
    <section className="relative min-h-[80vh] flex items-center justify-center text-center overflow-hidden">
      <img 
        src="/assets/images/hero-hands.png" 
        alt="Reaching for hope and unity in Zambian communities" 
        className="absolute inset-0 w-full h-full object-cover" 
      />
      <div className="absolute inset-0 bg-ehh-navy/60"></div>
      <div className="relative z-10 container mx-auto px-6 sm:px-8 md:px-12 max-w-5xl">
        <div className="py-12 sm:py-16 md:py-20">
          <img src="/logo.png" alt="EMA House of Hope Logo" className="mx-auto h-24 sm:h-28 md:h-32 mb-6 sm:mb-8" />
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-4 sm:mb-6 text-ehh-cream">
            Breaking Cycles of Poverty in Zambia
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl max-w-4xl mx-auto mb-4 leading-relaxed text-ehh-peach px-4 sm:px-0">
            EMA House of Hope is a faith-based organization dedicated to transforming lives in Zambia.
          </p>
          <p className="text-lg sm:text-xl md:text-2xl max-w-4xl mx-auto mb-8 sm:mb-10 leading-relaxed text-ehh-peach px-4 sm:px-0">
            EMA House of Hope (EHH) is a Non-government organisation registered and operating in Zambia since June 2024. The organisation is community-driven and geared to breaking the cycle of intergenerational poverty and hunger through advocacy for sustainable, ecosystem-level change.
          </p>
          <Link 
            to="/donate" 
            className="inline-block bg-ehh-orange text-ehh-cream px-8 py-4 sm:px-12 sm:py-5 rounded-lg text-lg sm:text-xl font-semibold hover:bg-ehh-coral transition-shadow shadow-xl"
          >
            Support Our Mission
          </Link>
        </div>
      </div>
    </section>

    {/* Integrated Model Teaser - Clean and centred */}
    <section className="py-24 px-6 bg-white">
      <div className="container mx-auto max-w-5xl text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-10">Our Integrated Model</h2>
        <p className="text-lg md:text-xl leading-relaxed max-w-4xl mx-auto mb-8">
          Our integrated model addresses the root causes of vulnerability by synchronizing interventions in foundational well-being, economic empowerment, and community health. We stabilise lives by meeting basic human needs, equip them with market-relevant skills and knowledge, and strengthen community systems to foster health, accountability, and sustainable growth.
        </p>
        <Link to="/about" className="inline-block text-ehh-orange hover:underline text-lg font-medium">
          Learn More About Us →
        </Link>
      </div>
    </section>

    {/* Three Pillars - Professional grid with images */}
    <section className="py-24 px-6 bg-ehh-navy/5">
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16">Our Three Pillars</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Social Protection */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <img 
              src="/assets/images/social-protection-hero.jpg" 
              alt="Community nutrition and support in Zambia" 
              className="w-full h-72 object-cover" 
            />
            <div className="p-10 text-center">
              <h3 className="text-2xl font-semibold text-ehh-orange mb-6">Social Protection</h3>
              <p className="text-base mb-8 leading-relaxed">Securing immediate dignity through nutrition, psycho-social support, and essential needs.</p>
              <Link to="/programs" className="text-ehh-orange hover:underline font-medium">
                Explore →
              </Link>
            </div>
          </div>

          {/* Integrated Community Health */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <img 
              src="/assets/images/community-health-hero.png" 
              alt="Mobile clinic and health advocacy in Zambian community" 
              className="w-full h-72 object-cover" 
            />
            <div className="p-10 text-center">
              <h3 className="text-2xl font-semibold text-ehh-orange mb-6">Integrated Community Health</h3>
              <p className="text-base mb-8 leading-relaxed">Mobile clinics and advocacy strengthening local health systems for generational resilience.</p>
              <Link to="/programs" className="text-ehh-orange hover:underline font-medium">
                Explore →
              </Link>
            </div>
          </div>

          {/* Economic Resilience */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <img 
              src="/assets/images/economic-resilience-hero.jpg" 
              alt="Skills training and entrepreneurship in Zambian community" 
              className="w-full h-72 object-cover" 
            />
            <div className="p-10 text-center">
              <h3 className="text-2xl font-semibold text-ehh-orange mb-6">Human Capital & Economic Resilience</h3>
              <p className="text-base mb-8 leading-relaxed">Market-driven vocational training and entrepreneurship fostering self-reliance.</p>
              <Link to="/programs" className="text-ehh-orange hover:underline font-medium">
                Explore →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Call to Action - Serene and focused */}
    <section className="py-24 px-6 text-center bg-ehh-orange/10">
      <div className="container mx-auto max-w-5xl">
        <h2 className="text-3xl md:text-5xl font-bold mb-10">Join the Transformation</h2>
        <p className="text-xl mb-12 max-w-3xl mx-auto leading-relaxed">
          Together, we create lasting ecosystem-level change—uplifting communities and securing brighter, self-reliant futures across generations.
        </p>
        <Link 
          to="/donate" 
          className="inline-block bg-ehh-orange text-ehh-cream px-12 py-5 rounded-lg text-xl font-semibold hover:bg-ehh-coral transition-shadow shadow-xl"
        >
          Donate Now
        </Link>
      </div>
    </section>
  </div>
);

export default Home;